import { ForwardedRef, forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import {
    AnchorItem,
    Arrow,
    CheckboxItem,
    Content,
    DropdownMenu,
    DropdownMenuAnchorItem,
    DropdownMenuArrow,
    DropdownMenuCheckboxItem,
    DropdownMenuCheckboxItemProps,
    DropdownMenuContent,
    DropdownMenuEllipsisTrigger,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuItemArrow,
    DropdownMenuItemIndicator,
    DropdownMenuItemProps,
    DropdownMenuLabel,
    DropdownMenuPortal,
    DropdownMenuProps,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuSeparator,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuTrigger,
    EllipsisTrigger,
    Group,
    Item,
    ItemArrow,
    ItemIndicator,
    Label,
    Portal,
    RadioGroup,
    RadioItem,
    Root,
    Separator,
    Sub,
    SubContent,
    SubTrigger,
    Trigger,
} from '@givebutter/primitives/dropdown-menu';
import { twMerge } from 'tailwind-merge';

interface DropdownMenuLinkItemProps extends LinkProps {
    bubbles?: boolean;
    disabled?: boolean;
    contentClassName?: string;
}

const DropdownMenuLinkItem = forwardRef(
    (props: DropdownMenuLinkItemProps, ref: ForwardedRef<HTMLAnchorElement>) => {
        const {
            children,
            contentClassName,
            className,
            bubbles = false,
            disabled,
            ...restProps
        } = props;

        if (disabled) {
            return (
                <DropdownMenuItem
                    disabled={disabled}
                    className={twMerge(className, contentClassName)}
                >
                    {children}
                </DropdownMenuItem>
            );
        }

        return (
            <Link
                className={twMerge('text-gray-900 no-underline hover:text-gray-900', className)}
                ref={ref}
                {...restProps}
            >
                <DropdownMenuItem
                    className={twMerge('focus-visible:before:border-0', contentClassName)}
                    onSelect={e => !bubbles && e.preventDefault()}
                >
                    {children}
                </DropdownMenuItem>
            </Link>
        );
    },
);
DropdownMenuLinkItem.displayName = 'DropdownMenuLinkItem';

const LinkItem = DropdownMenuLinkItem;

export {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuEllipsisTrigger,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuGroup,
    DropdownMenuItemIndicator,
    DropdownMenuItem,
    DropdownMenuItemArrow,
    DropdownMenuLinkItem,
    DropdownMenuAnchorItem,
    DropdownMenuCheckboxItem,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuArrow,
    DropdownMenuSeparator,
    DropdownMenuPortal,
    //
    Root,
    Trigger,
    EllipsisTrigger,
    Content,
    Label,
    Item,
    ItemArrow,
    LinkItem,
    Group,
    CheckboxItem,
    ItemIndicator,
    RadioGroup,
    RadioItem,
    Sub,
    SubContent,
    SubTrigger,
    Arrow,
    Separator,
    Portal,
    AnchorItem,
};

export type {
    DropdownMenuItemProps,
    DropdownMenuProps,
    DropdownMenuLinkItemProps,
    DropdownMenuCheckboxItemProps,
};
